<div class="f bg-gray-pale p-4 p-rx1 br-4"><cdn-svg class="m-r4" path="nucleo/medal"></cdn-svg><div class="t-xs gray">UPGRADE</div></div>